<template>
    <v-dialog
        v-model="dialog"
        max-width="80vw"
        max-height="80vh"
        v-if="dialog"
        :overlay-opacity="0.8"
    >
        <v-card tile>
            <v-toolbar color="upt" dense dark>
                Order - {{ orderId }}: {{ driverShiftId }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <AssignOrderToDriverShift
                v-if="order"
                :order="order"
                :driverShift="driverShift"
                :products="products"
                :station="order.station"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import { apiService } from '../../../services/apiService';
import AssignOrderToDriverShift from './AssignOrderToDriverShift.vue';

export default {
    name: 'AutoAssignQuantities',
    props: ['value', 'orderId', 'driverShiftId', 'stationId'],
    components: {
        AssignOrderToDriverShift
    },
    data() {
        return {
            order: null,
            driverShift: null,
            products: []
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    watch: {
        // Watch the orderId for changes
        orderId(newOrderId, oldOrderId) {
            if (newOrderId !== oldOrderId) {
                // Clear the previous data
                this.clearOrderData();

                // Fetch the new order data
                this.getOrderData();
            }
        }
    },
    mounted() {
        this.getProducts();
        this.getOrderData(); // Ensure getOrderData is called on mount
    },
    methods: {
        async getOrderData() {
            try {
                const [orderResponse, driverShiftResponse] = await Promise.all([
                    apiService.getOrder(this.orderId),
                    apiService.getDriverShift(this.driverShiftId)
                ]);

                if (orderResponse) {
                    this.order = orderResponse;
                }

                if (driverShiftResponse) {
                    this.driverShift = driverShiftResponse;
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getProducts() {
            try {
                if (this.products.length > 0) {
                    console.log('Products already loaded');
                    return;
                }
                const response = await apiService.getProducts();
                this.products = response.data;
                console.log('this.products', this.products);
            } catch (error) {
                console.error(error);
            }
        },
        clearOrderData() {
            this.order = null;
            this.driverShift = null;
            this.station = null;
        }
    }
};
</script>
